import React, { PureComponent } from "react";
import Grid from "@material-ui/core/Grid";
import { compose } from "recompose";
import { withApollo } from "react-apollo";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "js/components/Shared/Form/styles.js";
import { withRouter } from "react-router-dom";
import withPrograma from "js/hoc/withPrograma";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import { getField } from "js/components/Shared/Form/fieldGenerator";

const CustomField = ({ input, meta, fieldConfig }) => {
  const { tipo } = fieldConfig;
  return getField(tipo)({
    ...fieldConfig,
    input,
    meta
  });
};

class ProductosField extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderField = (field, index) => {
    if (
      !(
        field.key === "tasaDeAcreditacion" ||
        field.key === "limiteDiario" ||
        field.key === "limitePorFactura" ||
        field.key === "limiteMensual"
      )
    ) {
      return (
        <Grid item xs={12} md={6} key={index}>
          <Field name={field.key} component={CustomField} fieldConfig={field} />
        </Grid>
      );
    }
  };
  render() {
    const { classes, parametrosFacturaPorPuntos } = this.props;
    return (
      <form name="formFacturasPorPuntos">
        <Grid
          container
          alignItems="center"
          spacing={16}
          className={classes.gridCard}
        >
          {parametrosFacturaPorPuntos.map((field, index) =>
            this.renderField(field, index)
          )}
        </Grid>
      </form>
    );
  }
}

const formValuesSelector = formValueSelector("formFacturasPorPuntos");
const mapStateToPropsWithSelectors = (state, ownProps) => {
  const { parametrosFacturaPorPuntos, handleChange } = ownProps;

  const formValues = {};
  parametrosFacturaPorPuntos.forEach(field => {
    formValues[field.key] = formValuesSelector(state, field.key);
  });
  handleChange(formValues);
  return {
    formValues
  };
};

const enhance = compose(
  withPrograma,
  withRouter,
  withStyles(styles),
  withApollo,
  connect(mapStateToPropsWithSelectors),
  reduxForm({
    form: "formFacturasPorPuntos"
  })
);

export default enhance(ProductosField);
